<template>
  <v-content>
      
        <v-dialog 
           v-model="dialog"
           fullscreen
           >                                    
            <v-card style="display: flex; justify-content: center; flex-direction: column; max-width: 100%;">
                <v-btn
                    icon
                    dark
                    @click="dialog = false"
                    style="position: absolute; top: 10px; right: 10px; z-index: 9999;"
                    >
                        <v-icon style="color: #000000;">mdi-close</v-icon>
                    </v-btn>
                <!--<v-toolbar
                dense
                dark
                elevation="0"
                color="primary"
                max-height="48"
                >
                    <v-btn
                    icon
                    dark
                    @click="dialog = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>-->
                <div class="text-center">
                    <v-img
                    :lazy-src="$i18n.locale=='es'?'img/imagen-no-disponible.png' : 'img/imagen-no-disponible-en.png'"
                    :src="url"
					:key="token"
                    max-width="100%"
                    >
                    </v-img>                
                </div>
            </v-card>
        </v-dialog>
      
  </v-content>
</template>

<script>
import BaseModule from "../../common/BaseModule";

export default {
  name: "ImagesDialog",
  mixins: [BaseModule],
  components: {},
  data() {
    return {
      dialog: false,
      url: null,  
			token: null,       
    }
  },

  methods: {      
    showDialog(url, token) {
			console.log('showDialog() - url:' + url);
      this.url = url;
			this.token = token;
      this.dialog = true;
    },
  }
};
</script>